import type { SlotKey } from '#packages/apilib';
import type { __EditorAPI } from '#packages/rEditor';

export type EditorAPI = __EditorAPI;

export const EditorAPIKey: SlotKey<EditorAPI> = {
  name: 'EditorAPI',
  public: true,
};
